<template>
  <article class="panel question-card">
    <header class="question-header">
      <span class="question-number">第 {{ index + 1 }} 题</span>
      <span class="question-type">{{ typeWord }}</span>
      <span class="question-score">{{ Number(question.score) || 0 }} 分</span>
    </header>
    <div class="question-content">
      <div class="question-text" v-html="title"></div>
      <section v-for="section in sections" :key="section.title" class="question-section">
        <div class="question-section__title">{{ section.title }}</div>
        <div class="question-section__body" v-html="section.html"></div>
      </section>
      <QuestionAnswerInput :question="question" :value="value" :disabled="disabled" @input="$emit('input', $event)" />
    </div>
  </article>
</template>

<script>
import QuestionAnswerInput from './QuestionAnswerInput.vue'
import { QUESTION_TYPE, buildQuestionDisplaySections, getQuestionTitle, getQuestionType, getQuestionTypeWord } from '@/utils/questionDisplay'
export default {
  name: 'QuestionCard',
  components: { QuestionAnswerInput },
  props: { question: { type: Object, required: true }, index: { type: Number, required: true }, value: { default: '' }, disabled: { type: Boolean, default: false } },
  computed: {
    title() { return getQuestionTitle(this.question) },
    typeWord() { return this.question.question_type_word || getQuestionTypeWord(this.question) },
    sections() {
      const type = getQuestionType(this.question)
      return buildQuestionDisplaySections(this.question, { hideInteractiveBlocks: true, showAnswers: false }).filter(section => {
        if (type === QUESTION_TYPE.MATCHING) return false
        if (type === QUESTION_TYPE.ASSESSMENT && section.title === '测评选项') return false
        if (type === QUESTION_TYPE.WORD_SELECT && section.title === '候选词') return false
        if (type === QUESTION_TYPE.OPTIONAL && section.title === '选做子题') return false
        return true
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/tokens';
.question-card { display: grid; gap: 16px; padding: 24px; }
.question-header { display: flex; align-items: center; gap: 12px; padding-bottom: 14px; border-bottom: 1px solid $color-border-light; }
.question-number { color: $color-primary; font-weight: 800; }
.question-type { padding: 4px 10px; border-radius: var(--radius-sm); background: rgba($color-info, 0.1); color: $color-info; font-size: 12px; font-weight: 700; }
.question-score { margin-left: auto; color: $color-warning; font-weight: 800; }
.question-content { display: grid; gap: 16px; }
.question-text { color: $color-text-primary; font-size: 16px; line-height: 1.8; word-break: break-word; }
.question-section { display: grid; gap: 6px; }
.question-section__title { color: $color-text-secondary; font-size: 13px; font-weight: 800; }
.question-section__body { padding: 12px 14px; border: 1px solid $color-border-light; border-radius: var(--radius-md); background: $color-background; color: $color-text-secondary; line-height: 1.7; word-break: break-word; }
@media (max-width: 768px) { .question-header { align-items: stretch; flex-direction: column; } .question-score { margin-left: 0; } }
</style>
